(() => {
  const storageKey = 'aloe-collection-page-size';
  const allowedSizes = [24, 48, 100];

  const storedSize = (fallback) => {
    try {
      const value = Number.parseInt(window.localStorage.getItem(storageKey), 10);
      return allowedSizes.includes(value) ? value : fallback;
    } catch (_error) {
      return fallback;
    }
  };

  const storeSize = (value) => {
    try {
      window.localStorage.setItem(storageKey, String(value));
    } catch (_error) {
      // Storage can be unavailable in strict privacy modes; the selector still works for this page view.
    }
  };

  const format = (template, values) => Object.entries(values).reduce(
    (result, [key, value]) => result.replaceAll(`__${key.toUpperCase()}__`, String(value)),
    template
  );

  const mount = (container) => {
    const toolbars = [...container.querySelectorAll('[data-aloe-page-size]')];
    const grid = container.querySelector('#product-grid');
    if (!toolbars.length || !grid || grid.dataset.pageSizeReady === 'true') return;

    grid.dataset.pageSizeReady = 'true';
    const items = [...grid.children].filter((item) => item.classList.contains('grid__item'));
    const buttons = toolbars.flatMap((toolbar) => [...toolbar.querySelectorAll('[data-page-size-option]')]);
    const moreWrap = container.querySelector('[data-page-size-more-wrap]');
    const moreButton = container.querySelector('[data-page-size-more]');
    const pagination = container.querySelector('[data-page-size-pagination]');
    const fallback = Number.parseInt(toolbars[0].dataset.defaultSize, 10) || 48;
    let selectedSize = storedSize(fallback);
    let visibleCount = Math.min(selectedSize, items.length);

    const render = () => {
      items.forEach((item, index) => {
        item.hidden = index >= visibleCount;
      });

      buttons.forEach((button) => {
        const isActive = Number.parseInt(button.dataset.pageSizeOption, 10) === selectedSize;
        button.setAttribute('aria-pressed', String(isActive));
        button.classList.toggle('is-active', isActive);
      });

      const remaining = Math.max(items.length - visibleCount, 0);

      if (moreWrap && moreButton) {
        moreWrap.hidden = remaining === 0;
        moreButton.textContent = remaining === 0
          ? toolbars[0].dataset.completeLabel
          : format(toolbars[0].dataset.moreTemplate, { count: Math.min(selectedSize, remaining) });
      }

      if (pagination) pagination.hidden = remaining > 0;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedSize = Number.parseInt(button.dataset.pageSizeOption, 10);
        visibleCount = Math.min(selectedSize, items.length);
        storeSize(selectedSize);
        render();
      });
    });

    moreButton?.addEventListener('click', () => {
      const firstRevealedIndex = visibleCount;
      visibleCount = Math.min(visibleCount + selectedSize, items.length);
      render();
      items[firstRevealedIndex]?.querySelector('a, button, input, select')?.focus({ preventScroll: true });
    });

    render();
  };

  const mountAll = () => document.querySelectorAll('[id^="shopify-section-template-"]').forEach((container) => mount(container));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  else mountAll();

  new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length)) mountAll();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', mountAll);
})();
